import { App } from '@jfs/mportalflow'
import { createRoot } from 'react-dom/client'
import './assets/css/index.css'
import './ieConfig/MobxConfig'
import './ieConfig/Polyfills'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)
